import React, { useEffect, useState } from "react";
import { Card, Button, Row, Col, Flex, Select, DatePicker, Modal } from "antd";
import {
	ArrowUpOutlined,
	ArrowDownOutlined,
	FileExcelOutlined,
	FileAddFilled,
} from "@ant-design/icons";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import dayjs from "dayjs";
import { CustomSpinner } from "../utils/CustomComponents";
import AddMaterialUsageByMix from "./AddMaterialUsageByMix";
const { RangePicker } = DatePicker;

const MaterialUsageByMixList = () => {
	const [sortOrder, setSortOrder] = useState("asc");
	const [plantOptions, setPlantOptions] = useState([]);
	const [subplantOptions, setSublantOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingSubplant, setLoadingSubplant] = useState(true);
	const [plant, setPlant] = useState(undefined);
	const [subplant, setSubplant] = useState(undefined);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [data, setData] = useState([]);
	const [modalMaterialUsageOpen, setModalMaterialUsageOpen] = useState(false);
	const [refresh, setRefresh] = useState(false);

	useEffect(() => {
		getPlant();
	}, []);

	useEffect(() => {
		if (plant && subplant) getFiles();
	}, [startDate, endDate, plant, subplant, refresh]);

	const getFiles = async () => {
		setLoading(true);

		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/files/get/materialusage/list?startDate=${start}&endDate=${end}&plant=${plant}&subplant=${subplant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						dateFormat: dayjs(item.createdAt).format("MM/DD/YYYY HH:mm A"),
						date: item.createdAt,
						user: item.createdBy.name,
						plant: item.plant.name,
						subplant: item.subplant,
						fileName: item.fileName,
						url: item.url,
					});
				});
				setData(list);
			} else {
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const sortedData = [...data].sort((a, b) => {
		if (sortOrder === "asc") return new Date(a.date) - new Date(b.date);
		return new Date(b.date) - new Date(a.date);
	});

	const getPlant = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let plantList = [];
			data.payload.map((item) => {
				plantList.push({
					label: item.name,
					value: item._id,
				});
			});
			setPlantOptions(plantList);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getSublant = async (currentPlant) => {
		const url = api + `/plant/${currentPlant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let subplantList = [];
			data.subplants.map((item) => {
				subplantList.push({
					label: item.name,
					value: item.name,
				});
			});
			setSublantOptions(subplantList);
			setLoadingSubplant(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const onChangePlant = (value) => {
		setData([]);
		setPlant(value);
		setSubplant(undefined);
		setLoadingSubplant(true);
		getSublant(value);
	};

	const onCompleteAddedFile = () => {
		setRefresh((prev) => !prev);
		setModalMaterialUsageOpen((prev) => !prev);
	};

	const RenderSearch = () => {
		return (
			<Row gutter={16}>
				<Col span={4}>
					<RangePicker
						defaultValue={[
							dayjs(startDate, "MM/DD/YYYY"),
							dayjs(endDate, "MM/DD/YYYY"),
						]}
						format={"MM/DD/YYYY"}
						size="large"
						disabled={loading}
						allowClear={false}
						style={{ width: "100%" }}
						onChange={onRangeChange}
					/>
				</Col>
				<Col span={4}>
					<Select
						showSearch
						placeholder={`Select plant`}
						optionFilterProp="children"
						size="large"
						filterOption={filterOption}
						options={plantOptions}
						onChange={onChangePlant}
						style={{
							width: "100%",
						}}
						value={plant}
					/>
				</Col>
				<Col span={4}>
					<Select
						showSearch
						placeholder={`Select subplant`}
						optionFilterProp="children"
						size="large"
						filterOption={filterOption}
						options={subplantOptions}
						disabled={loadingSubplant}
						onChange={(value) => setSubplant(value)}
						style={{
							width: "100%",
						}}
						value={subplant}
					/>
				</Col>
			</Row>
		);
	};

	const ModalComments = () => {
		return (
			<Modal
				title="Add Material Usage By Mix"
				open={modalMaterialUsageOpen}
				onCancel={() => setModalMaterialUsageOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<AddMaterialUsageByMix onSuccess={onCompleteAddedFile} />
			</Modal>
		);
	};

	return (
		<Layout title="Upload Files" description="Files">
			<Flex vertical gap={20} style={{ marginBottom: 20 }}>
				<RenderSearch />
				<Flex gap={10}>
					<Button
						onClick={() => setModalMaterialUsageOpen(true)}
						size="large"
						type="primary"
					>
						<FileAddFilled />
						Add File
					</Button>
					<Button
						onClick={() => setSortOrder(sortOrder === "asc" ? "desc" : "asc")}
						size="large"
					>
						{sortOrder === "asc" ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
						Sort by Date
					</Button>
				</Flex>

				<ModalComments />
			</Flex>
			{loading ? (
				<CustomSpinner />
			) : (
				<Row gutter={[16, 16]} style={{ width: "100%" }}>
					{sortedData.map((item, index) => (
						<Col key={index} span={6}>
							<Card
								hoverable
								style={{
									textAlign: "center",
									borderRadius: 12,
									cursor: "pointer",
								}}
								onClick={() => window.open(item.url, "_blank")}
							>
								<div
									style={{
										width: 80,
										height: 80,
										borderRadius: "50%",
										backgroundColor: "#e6f4ea",
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										margin: "0 auto 12px",
									}}
								>
									<FileExcelOutlined style={{ fontSize: 40, color: "green" }} />
								</div>

								<p style={{ margin: 0, color: "#555" }}>{item.fileName}</p>
								<h3 style={{ marginTop: 16 }}>
									{item.plant} ({item.subplant})
								</h3>
								<p style={{ margin: 0, color: "#555" }}>{item.dateFormat}</p>
								<p style={{ margin: 0, color: "#999" }}>{item.user}</p>
							</Card>
						</Col>
					))}
				</Row>
			)}
		</Layout>
	);
};

export default MaterialUsageByMixList;
